<ng-container *ngIf="_isLoaded">
  <div id="container{{_id}}"
       [style]="_style"
       class="{{_class}}{{classesRequired}}"
       [ngStyle]="_ngStyle"
       [ngClass]="_ngClass">

    <input
           #Input
           type="date"
           name="{{_name}}"
           id="{{_id}}"
           [ngModel]="qDateService.ToString(_qNgModel)"
           [max]="_max"
           [min]="_min"
           [step]="_step"
           [style]="_style"
           class="{{_class}}{{classesRequired}}"
           [ngStyle]="_ngStyle"
           [ngClass]="_ngClass"
           [autofocus]="_autofocus"
           [disabled]="_disabled"
           list="datalist"
           [readonly]="_readonly"
           [required]="_required"
           [tabindex]="_tabindex"
           [title]="_title"
           (change)="OnChange($event)"
           (blur)="OnBlur($event)"
           (click)="OnClick($event)"
           (dblclick)="OnDblclick($event)"
           (focus)="OnFocus($event)"
           (keydown)="OnKeydown($event)"
           (keypress)="OnKeypress($event)"
           (keyup)="OnKeyup($event)" />
  </div>
  <small *ngIf="!_isValid && !_nullable" class="q-c-danger w-100">Date non valide</small>

  <ng-container *ngIf="_list.length > 0">
    <datalist *ngFor="let value of _list" id="datalist">
      <option [value]="value"></option>
    </datalist>
  </ng-container>
</ng-container>
